require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-be-a-good-e-commerce-copywriter.json") })
        }
      }, "path---blog-how-to-be-a-good-e-commerce-copywriter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-be-a-good-e-commerce-copywriter!./.cache/json/blog-how-to-be-a-good-e-commerce-copywriter.json
// module id = 456
// module chunks = 231608221292675